import { useStoreState } from 'easy-peasy';
import React, { Suspense, useEffect } from 'react';
import { lazyLoader } from 'utils/componentLoader';
import { Redirect, BrowserRouter, Switch, Route } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import { mutate } from 'utils/relay';
import routes from 'routes';
import { isEmpty } from 'utils/utils';
import Loader from 'components/loader';
import RouteNotFound from 'components/auth/RouteNotFound';
import UpgradeToProPlanModal from 'components/pro-feature/modal';
import { CreateOrUpdateFcmDevice } from 'components/settings/graphql/mutation/CreateOrUpdateFcmDevice';
import { messaging, isBrowserSupported } from 'components/Firebase/Firebase';
import CHOICES from 'CHOICES';

const { WEB } = CHOICES.DeviceChoices;

const Login = lazyLoader(() => import('components/auth/Login'));
const Navigation = lazyLoader(() => import('components/Navigation'));
const ForgotPassword = lazyLoader(() => import('components/password/Forgot_new'));
const ResetPassword = lazyLoader(() => import('components/password/Reset'));
const Preview = lazyLoader(() => import('components/Preview'));
const PrivacyPolicy = lazyLoader(() => import('components/Privacy'));
const PublicSales = lazyLoader(() => import('components/unprotected/sales/SalesCard'));
const PublicInbox = lazyLoader(() => import('components/unprotected/inbox'));
const PaymentRoutes = lazyLoader(() => import('components/unprotected/payment/Routes'));
const Subsription = lazyLoader(() => import('components/clients/public/main'));
const LandingPagePreview = lazyLoader(() => import('components/unprotected/landingPage/preview'));
const PublicPaymentMethod = lazyLoader(() => import('components/clients/public/paymentMethod'));
const PublicReport = lazyLoader(() => import('components/unprotected/report'));
const LinkSent = lazyLoader(() => import('components/password/LinkSent'))

const App = () => {
	const authToken = useStoreState(state => state.authToken);
	const showProPlanModal = useStoreState(state => state.showProPlanModal);

	// onMessageListener().then(payload => {
	// }).catch(err => console.log('failed: ', err));

	useEffect(() => {
		if (authToken) {
			let firebaseMessage = null;
			if (isBrowserSupported) {
				firebaseMessage = messaging;
			}
			if (!firebaseMessage) return;
			firebaseMessage.getToken().then(token => {
				if (token)
					mutate({
						mutation: CreateOrUpdateFcmDevice,
						input: { registrationId: token, deviceType: WEB },
						onSuccess: function () {

						}
					});
			}).catch(e => {
				console.log(e);
			});
			firebaseMessage.onMessage(payload => {
				const notificationTitle = payload.notification.title;
				const notificationOptions = {
					body: payload.notification.body,
					icon: '/eb-new-favicon.ico'
				};
				if (!('Notification' in window)) {
					console.log('This browser does not support system notifications');
				}
				// Let's check whether notification permissions have already been granted
				else if (Notification.permission === 'granted') {
					// If it's okay let's create a notification
					var notification = new Notification(notificationTitle, notificationOptions);
					console.log('This browser supports system notifications', payload);
					notification.onclick = function (event) {
						event.preventDefault(); // prevent the browser from focusing the Notification's tab
						window.open(payload.notification.click_action, '_blank');
						notification.close();
					};
				}
			});
		}
	}, [authToken]);

	return (
		<>
			<ToastContainer
				autoClose={2500}
				pauseOnHover={false}
			/>
			<BrowserRouter>
				<Suspense fallback={<Loader />}>
					{showProPlanModal && <UpgradeToProPlanModal />}
					<Switch>
						<Route path={routes.forgotPassword} component={ForgotPassword} />
						<Route path={routes.linkSent} component={LinkSent} />
						<Route path={`${routes.publicClient}/:clientId/payment-method`} component={PublicPaymentMethod} exact />
						<Route path={`${routes.publicClient}/:clientId/subscription`} component={Subsription}
							exact />
						{isEmpty(authToken) && <Route path={routes.payments} component={PaymentRoutes} />}
						<Route path={`${routes.landingPage}/:botName/:botId/`} component={LandingPagePreview} exact />
						<Route path={`${routes.landingPage}/:botId`} component={LandingPagePreview} exact />
						<Route path={`${routes.resetPassword}/:id`} component={ResetPassword} exact />
						<Route path={routes.login} render={(props) => <Login {...props} />} exact />
						<Route path={`${routes.salesPublic}/:cardId`} component={PublicSales} exact />
						<Route path={`${routes.preview}/:botId`} component={Preview} exact />
						<Route path={`${routes.privacy}/:clientId`} component={PrivacyPolicy} exact />
						<Route path={`${routes.inboxPublic}/pipeline/:pipelineId/:cardId`} component={PublicInbox} />
						<Route path={`${routes.inboxPublic}/bot/:botId/:cardId`} component={PublicInbox} />
						<Route path={`${routes.inboxPublic}/:cardId`} component={PublicInbox} />
						<Route path={`${routes.reportPublic}/:botId`} component={PublicReport} />
						<Route path={'/page-not-found'} component={RouteNotFound} />
						{!isEmpty(authToken) && <Route path='/' component={Navigation} />}
						{isEmpty(authToken) && <Redirect to={routes.login} />}
					</Switch>
				</Suspense>
			</BrowserRouter>
		</>
	);
};

export default App;
